import { SUBSCRIPTIONS_TAB_TIMEOUT } from '../src/subscriptionsTabTimeout';
export { SUBSCRIPTIONS_TAB_TIMEOUT };
